var _path, _path2, _g, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 392.727 392.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M278.756 130.424V22.077H113.778v108.347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#56ace0",
    d: "M135.564 43.863h121.341v86.497H135.564z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffc10d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.028 152.21l-16.097 36.655h204.736L282.57 152.21zM21.851 327.402h43.572v43.572H21.851z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#56ace0",
    d: "M174.481 327.402h43.572v43.572h-43.572z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc10d",
    d: "M327.176 327.402h43.572v43.572h-43.572z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M381.737 305.487h-21.85v-47.451c0-6.012-4.848-10.925-10.925-10.925H207.257v-36.525H315.41c7.822 0 13.188-8.339 9.956-15.321l-24.76-56.307V11.022c0-6.012-4.913-10.925-10.99-10.925H102.917c-5.947 0-10.925 4.848-10.925 10.925v127.806l-24.76 56.307c-2.844 6.012 1.293 15.321 9.956 15.321h108.154v36.525H43.636c-6.012 0-10.925 4.848-10.925 10.925v47.451H10.925C4.913 305.358 0 310.206 0 316.283v65.422c0 6.012 4.848 10.925 10.925 10.925h65.422c6.012 0 10.925-4.848 10.925-10.925v-65.422c0-6.012-4.848-10.925-10.925-10.925H54.626v-36.525H185.47v36.525h-21.786c-6.012 0-10.925 4.848-10.925 10.925v65.422c0 6.012 4.848 10.925 10.925 10.925h65.422c6.012 0 10.925-4.848 10.925-10.925v-65.422c0-6.012-4.848-10.925-10.925-10.925H207.32v-36.525h130.844v36.525H316.38c-6.012 0-10.925 4.848-10.925 10.925v65.422c0 6.012 4.848 10.925 10.925 10.925h65.422c6.012 0 10.925-4.848 10.925-10.925v-65.422c-.129-5.948-4.978-10.796-10.99-10.796zm-316.25 65.422H21.851v-43.572h43.572v43.572h.064zm152.63 0h-43.572v-43.572h43.572v43.572zM113.907 21.947h164.978v108.347H113.907V21.947zM93.931 188.671l16.097-36.655H282.57l16.097 36.655H93.931zm276.881 182.238H327.24v-43.572h43.572v43.572z",
    fill: "#194f82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/Integration.c1432780.svg";
export { ForwardRef as ReactComponent };